/**
 * QR codes as one SVG path: dark squares, a rectangle per run of them in a row. The encoder (uqr,
 * MIT) loads the first time a code is made, so it adds nothing to what the app loads at start.
 */

export interface QrDrawing {
  /** Squares across (and down). */
  size: number;
  /** The dark squares, in square units from the top left. */
  path: string;
}

/** The dark squares (`rows[y][x]`) as one SVG path: a rectangle per run of dark squares in a row. */
export function qrPath(rows: readonly (readonly boolean[])[]): string {
  let d = '';
  rows.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (!row[x]) {
        x++;
        continue;
      }
      const start = x;
      while (row[x]) x++;
      d += `M${String(start)} ${String(y)}h${String(x - start)}v1h${String(start - x)}z`;
    }
  });
  return d;
}

/** The QR code of `text`, at medium error correction (a smudged screen still reads). */
export async function qrDrawing(text: string): Promise<QrDrawing> {
  const { encode } = await import('uqr');
  const qr = encode(text, { ecc: 'M', border: 0 });
  return { size: qr.size, path: qrPath(qr.data) };
}
